import { Box } from '@zillow/constellation-10';
import { css } from '@/styled-system/css';
import { FunctionComponentWithChildren } from 'src/utils/types';
/**
 * Stories for DashboardPageLayout handle this component
 */
/* eslint-disable local-rules/require-storybook-documentation */

export const BaseSkeleton: FunctionComponentWithChildren = ({ children }) => (
    <Box
        className={css({
            background: 'linear-gradient(-90deg, #efefef 0%, #fcfcfc 50%, #efefef 100%)',
            backgroundSize: '400% 400%',
            animation: 'pulse 1.2s ease-in-out infinite',
        })}>
        {children}
    </Box>
);
